/* eslint-disable security/detect-unsafe-regex */
/* eslint-disable sonarjs/no-duplicate-string */
import React, { FC } from 'react'
import LayoutDefault from '@/components/layouts/Layout'
import SectionHeaderService from '@/components/modules/SectionHeaderService'
import TitleShadow from '@/components/modules/TitleShadow'
import Benefit from '@/components/modules/Benefit'
import ListBullet from '@/components/modules/ListBullet'
import ServiceItem from '@/components/modules/ServiceItem'
import PortfolioItem from '@/components/modules/PortfolioItem'
import WarrantyItem from '@/components/modules/WarrantyItem'
import ServiceGetInTouch from '@/components/modules/ServiceGetInTouch'
import Button from '@/components/elements/Button'
import ImgResponsive from '@/components/elements/ImgResponsive'
import Router from 'next/router'

import Link from 'next/link'
import { FaArrowRight } from 'react-icons/fa'

const ServicePage: FC = () => {
  return (
    <LayoutDefault>
      <SectionHeaderService
        bgColors='#06B7B7'
        bgImage='/images/service/Twin_Service_WebDev.webp'
        bgImageMd='/images/service/Twin_Service_WebDev.webp'
        bgImageSm='/images/service/Twin_Service_WebDev.webp'
        title={<>&quot;เพิ่มศักยภาพให้กับธุรกิจของคุณด้วยเว็บไซต์ที่มีประสิทธิภาพ&quot;</>}
        description='"Empowering your business with the Excellence website"'
        bgImageWidth={1214}
        bgImageHeight={534}
        btnText='ปรึกษาเรื่องการพัฒนาเว็บไซต์'
        onClick={() => Router.push('/contact-service')}
        prologue='การพัฒนา'
        colorPrologue='rgba(0,0,0,.08)'
        titleShadow='พัฒนาเว็บไซต์'
        colorTitleShadow='#000000'
        align='center'
        content={
          <>
            <p className='text-center'>
              หรือการสร้างเว็บไซต์ที่มีคุณภาพและสามารถทำงานได้อย่างมีประสิทธิภาพคือกุญแจอันสำคัญที่จะนำธุรกิจของท่านไปสู่ความสำเร็จบนโลกออนไลน์
              ซึ่งโลกปัจจุบันเราไม่สามารถที่จะปฏิเสธได้เลยว่าเว็บไซต์สำคัญต่อการสร้างแบรนด์ที่น่าเชื่อถือ
              เป็นช่องทางในการทำการตลาดและเป็นช่องทางในการ เพิ่มรายได้ให้กับธุรกิจแทบทุกธุรกิจ
              ดังนั้นการให้ความสำคัญในการพัฒนาเว็บไซต์ย่อมเป็นสิ่งจำเป็นอย่างมากในการเพิ่มศักยภาพให้กับธุรกิจ
            </p>
            <p className='text-center'>
              Twin Synergy คือทีมพัฒนาเว็บไซต์ที่มีประสบการณ์และมีความเชี่ยวชาญสูง เราสามารถแนะนำ
              เทคโนโลยีและโซลูชั่นที่ดีที่สุดในการพัฒนาเว็บไซต์ ให้เหมาะสมกับความต้องการการของลูกค้า
              การประเมินราคาและระยะเวลาของโครงการที่แม่นยำ
              โดยเราให้ความสำคัญในการบริหารโครงการอย่างมีประสิทธิภาพและโปร่งใสรวมถึงมุ่งเน้น
              การดูแลและการให้บริการลูกค้า โดยยึดเอาความพึงพอใจของลูกค้าเป็นหลัก
            </p>
            <div className='text-center'>
              <Button
                htmlType='button'
                className='btn-neutral'
                onClick={() => Router.push('/contact-service')}
              >
                สอบถามข้อมูลเพิ่มเติม
              </Button>
            </div>
          </>
        }
      />
      <div className='pb-24 lg:pb-0 xl:pt-44'>
        <div className='container mx-auto space-y-8 px-4 lg:pt-44 xl:pt-0'>
          <TitleShadow
            rootClassName='max-w-5xl mx-auto'
            prologue='คุณสมบัติที่สำคัญ'
            colorPrologue='rgba(0,0,0,.08)'
            title={
              <>
                คุณสมบัติที่สำคัญในการให้บริการ
                <br />
                พัฒนาเว็บไซต์ของเรา
              </>
            }
            colorTitle='#000000'
            align='center'
          />
          <div className='grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-16'>
            <Benefit
              className='border-none text-content-base'
              title={
                <>
                  ที่สวยงาม
                  <br />
                  และมีความลงตัว
                </>
              }
              prologue='01'
              subtitle='ออกแบบเว็บไซต์'
              subTitlePosition='top'
              colorPrologue='rgba(0,0,0,.08)'
              colorTitle='#000000'
              colorSubtitle='#000000'
              description={
                <p>
                  เราเข้าใจว่าเว็บไซต์ของคุณต้องไม่เหมือนใคร (Unique Design)
                  และต้องแสดงถึงความเป็นเอกลักษณ์ของธุรกิจของคุณ
                  โดยคุณสามารถกำหนดมันได้เองเพื่อเติมเต็มให้กับแบรนด์ของคุณและส่งมอบสิ่งดี ๆ
                  ให้กับลูกค้าของคุณ
                </p>
              }
              rootTitleStyle={{
                padding: '130px 0 50px',
              }}
            />
            <Benefit
              className='border-none text-content-base'
              title={
                <>
                  เหมาะสม
                  <br />
                  กับทุกอุปกรณ์
                </>
              }
              prologue='02'
              subtitle='เว็บไซต์ที่ดีต่อผู้เข้าชม'
              subTitlePosition='top'
              colorPrologue='rgba(0,0,0,.08)'
              colorTitle='#000000'
              colorSubtitle='#000000'
              description={
                <p>
                  เราให้ความสำคัญกับการออกแบบเว็บไซต์ที่ไม่เพียงแค่มีความสวยงาม แต่ยังใช้งานง่าย
                  (User Friendly) และต้องสามารถปรับตัวได้กับอุปกรณ์มือถือ (Mobile Responsive)
                  และอุปกรณ์อื่น ๆ
                  ที่มีขนาดหน้าจอต่างกันไปเพื่อเสริมประสบการณ์การเรียกดูเว็บไซต์ที่สวยงามอย่างต่อเนื่องให้กับผู้เข้าชมเว็บไซต์
                </p>
              }
              rootTitleStyle={{
                padding: '130px 0 50px',
              }}
            />
            <div className='lg:col-span-2'>
              <ImgResponsive
                src='/images/service/middle_sevice_webdev.webp'
                alt='Twin Synergy service'
                sourceImgSm='/images/service/middle_sevice_webdev.webp'
                sourceImgMd='/images/service/middle_sevice_webdev.webp'
                loadingLazy
                className='mx-auto'
              />
            </div>
            <Benefit
              className='border-none text-content-base'
              title={
                <>
                  และการทำงาน
                  <br />
                  ที่ดีต่อเนื่อง
                </>
              }
              prologue='03'
              subtitle='ประสิทธิภาพ'
              subTitlePosition='top'
              colorPrologue='rgba(0,0,0,.08)'
              colorTitle='#000000'
              colorSubtitle='#000000'
              description={
                <p>
                  ให้ความสำคัญกับความทันสมัยของเทคโนโลยีที่เลือกใช้ในการพัฒนาเว็บไซต์
                  เพื่อสร้างเว็บไซต์ที่มีคุณภาพและทำงาน
                  ได้อย่างมีประสิทธิภาพรวมถึงการดูแลซัพพอร์ทและการบำรุงรักษาให้เว็บไซต์สามารถทำงานได้อย่างราบรื่นและรวดเร็ว
                  เพื่อมอบประสบการณ์การใช้งานที่ดีเยี่ยมให้กับผู้เข้าชมเว็บไซต์ของคุณ
                </p>
              }
              rootTitleStyle={{
                padding: '130px 0 50px',
              }}
            />
            <Benefit
              className='border-none text-content-base'
              title={
                <>
                  และทำงานร่วม
                  <br />
                  กับระบบอื่น ๆ
                </>
              }
              prologue='04'
              subtitle='รองรับการทำ SEO'
              subTitlePosition='top'
              colorPrologue='rgba(0,0,0,.08)'
              colorTitle='#000000'
              colorSubtitle='#000000'
              description={
                <p>
                  เราคำนึงถึงหลักการของการทำ SEO ระหว่างกระบวนการพัฒนาเว็บไซต์เสมอ
                  เพื่อเพิ่มความสามารถในการค้นหาบน Google แบบออแกนิค
                  อีกทั้งยังคำนึงถึงการนำระบบที่สำคัญอื่น ๆ
                  มาเชื่อมต่อกับเว็บไซต์เพื่อเพิ่มศักยภาพทั้งในด้านการตลาดก็ดี การขายก็ดี
                  หรือการวิเคราะห์ข้อมูลก็ดี
                </p>
              }
              rootTitleStyle={{
                padding: '130px 0 50px',
              }}
            />
          </div>
        </div>
      </div>
      <div>
        <div className='container mx-auto space-y-8 px-4 pb-24'>
          <h3 className='mb-16 text-3xl'>Experiences</h3>
          <div className=''>
            <ListBullet
              className='grid grid-cols-1 lg:grid-cols-3'
              list={[
                'Radio Streaming Platform',
                'Music Streaming Platform',
                'VDO Streaming Platform',
                'Community Platform',
                'Booking Platform',
                'Sport Tournament Platform',
                'E-Learning Platform',
                'E-Commerce',
              ]}
            />
          </div>
        </div>
      </div>
      <div className='bg-neutral py-28'>
        <div className='container mx-auto space-y-8 px-4'>
          <div className='grid grid-cols-1 items-center gap-4 text-white lg:grid-cols-2 xl:gap-8'>
            <ImgResponsive
              src='/images/service/service_contact.webp'
              alt='Twin Synergy service'
              sourceImgSm='/images/service/service_contact.webp'
              sourceImgMd='/images/service/service_contact.webp'
              loadingLazy
              className='mx-auto'
            />
            <div className='space-y-6'>
              <h2 className='xl:text-7xl'>
                หากคุณกำลังมอง<span>หาทีมพัฒนาเว็บไซต์</span>
              </h2>
              <p className='font-bold xl:text-4xl'>
                ที่มีความเชี่ยวชาญสูงและมีประสบการณ์
                การพัฒนาเว็บไซต์หรือแพลตฟอร์มที่ต้องใช้เทคโนโลยีชั้นสูง ติดต่อเรามาได้เลยตอนนี้
              </p>
              <p>
                เรายินดีให้คำปรึกษาและประเมินงบประมาณในการพัฒนา โดยทีมงานผู้เชี่ยวชาญ
                และมีประสบการณ์มากกว่า 12 ปี
              </p>
              <Button
                htmlType='button'
                className='btn-warning'
                onClick={() => Router.push('/contact')}
              >
                ปรึกษาทีมผู้เชี่ยวชาญ
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className='pt-24 lg:pt-44'>
        <div className='container mx-auto space-y-8 px-4 pb-14 xl:pt-0'>
          <TitleShadow
            prologue='ผลงาน'
            colorPrologue='rgba(0,0,0,.08)'
            title={<>ผลงานของเรา</>}
            colorTitle='#000000'
            align='center'
          />
        </div>
        <div className='grid grid-cols-2 lg:grid-cols-4'>
          <PortfolioItem
            title='Atime.live'
            categories='website'
            serviceImg='/images/service/website/Atime_live.webp'
            serviceBg='#FFCA64'
            slug='/portfolio/atime-live'
          />
          <PortfolioItem
            title='Spicydisc'
            categories='website'
            serviceImg='/images/service/website/Spicydisc.webp'
            serviceBg='#FFCA64'
            slug='/portfolio/spicydisc'
          />
          <PortfolioItem
            title='Smaklen.club'
            categories='website'
            serviceImg='/images/service/website/Smaklen_club.webp'
            serviceBg='#FFCA64'
            slug='/portfolio/smaklen-club'
          />
          <PortfolioItem
            title='Brandthink shop'
            categories='website'
            serviceImg='/images/service/website/Brandthink_shop.webp'
            serviceBg='#FFCA64'
            slug='/portfolio/brandthink-shop/'
          />
        </div>
        <div className='bg-neutral text-center'>
          <Link
            className='flex items-center justify-center py-4 font-light text-white'
            href='/portfolio'
          >
            ดูโปรเจกต์ทั้งหมด <FaArrowRight className='ml-2' size={14} />
          </Link>
        </div>
        <div className='warranty grid grid-cols-2 lg:grid-cols-5'>
          <WarrantyItem
            content={
              <>
                Warrantee Source
                <br />
                code 1 year
              </>
            }
            serviceImg='/images/service/warratee.webp'
            serviceBg='#F7F8F9'
          />
          <WarrantyItem
            content={
              <>
                Support team (8/7)
                <br />6 month
              </>
            }
            serviceImg='/images/service/support_team.webp'
            serviceBg='#F7F8F9'
          />
          <WarrantyItem
            content='Free MA 6 month'
            serviceImg='/images/service/free_MA.webp'
            serviceBg='#F7F8F9'
          />
          <WarrantyItem
            content={
              <>
                Free consultant
                <br />
                Forever
              </>
            }
            serviceImg='/images/service/free_consultant.webp'
            serviceBg='#F7F8F9'
          />
          <WarrantyItem
            content={
              <>
                Free integration
                <br />
                service fee
              </>
            }
            serviceImg='/images/service/free_integration.webp'
            serviceBg='#F7F8F9'
          />
        </div>
      </div>
      <div className='bg-author-base py-24'>
        <ServiceGetInTouch content='เว็บไซต์คือกุญแจสำคัญในการสร้างความสำเร็จให้กับธุรกิจของคุณ มาเปิดโอกาสทางธุรกิจของคุณไปพร้อมกับเว็บไซต์ที่มีคุณภาพไม่เหมือนใคร ติดต่อเราเพื่อรับข้อมูลเพิ่มเติมและเริ่มต้นโปรเจคของคุณวันนี้!' />
      </div>
      <div className='section-service pt-24 lg:pt-44'>
        <div className='container mx-auto space-y-8 px-4 pb-14 xl:pt-0'>
          <TitleShadow
            prologue='บริการ'
            colorPrologue='rgba(0,0,0,.08)'
            title='บริการอื่น ๆ'
            colorTitle='#000000'
            align='center'
          />
        </div>
        <div className='grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4'>
          <ServiceItem
            prologue='01'
            title='พัฒนาเว็บไซต์'
            serviceImg='/images/service/service-01.webp'
            serviceBg='#06B7B7'
            serviceUrl='website-development'
          />
          <ServiceItem
            prologue='02'
            title='พัฒนาแอปพลิเคชั่นมือถือ'
            serviceImg='/images/service/service-02.webp'
            serviceBg='#1990FF'
            serviceUrl='mobile-application-development'
          />
          <ServiceItem
            prologue='03'
            title='ออกแบบเว็บไซต์'
            serviceImg='/images/service/service-03.webp'
            serviceBg='#FFCA64'
            serviceUrl='website-design'
          />
          <ServiceItem
            prologue='04'
            title='เว็บไซต์สำหรับธุรกิจ SME'
            serviceImg='/images/service/service-04.webp'
            serviceBg='#FFAC79'
            serviceUrl='sme-website-development'
          />
          <ServiceItem
            prologue='05'
            title='ออกแบบและพัฒนา Line OA'
            serviceImg='/images/service/service-05.webp'
            serviceBg='#00BE00'
            serviceUrl='line-oa-development'
          />
          <ServiceItem
            prologue='06'
            title='พัฒนาซอฟต์แวร์ตามกำหนด'
            serviceImg='/images/service/service-06.webp'
            serviceBg='#FF7D7D'
            serviceUrl='custom-software-development'
          />
          <ServiceItem
            prologue='07'
            title='เพิ่มความปลอดภัย'
            serviceImg='/images/service/no-service.webp'
            serviceBg='#B577E5'
            noLink
          />
          <ServiceItem
            prologue='08'
            title='ดูแลบำรุงรักษาเว็บไซต์'
            serviceImg='/images/service/no-service.webp'
            serviceBg='#484848'
            noLink
          />
        </div>
      </div>
    </LayoutDefault>
  )
}

export default ServicePage
